<template>
  <div id="app" @click="wrapperClickMethods">
    <app-header :headerTitle="headerTitle" :headerType="headerType"></app-header>
    <router-view></router-view>
    <app-search v-if="isSearchShown"></app-search>
    <app-footer></app-footer>
    <app-bg-layer></app-bg-layer>
    <app-light-box></app-light-box>
  </div>
</template>
<script>
  import Header from './components/common/Header.vue';
  import Footer from './components/common/Footer.vue';
  import BgLayer from './components/common/BgLayer.vue';
  import LightBox from './components/lightbox/Home.vue';
  import Search from './components/search/Search.vue';

  export default {
    components: {
      appHeader: Header,
      appFooter: Footer,
      appBgLayer: BgLayer,
      appLightBox: LightBox,
      appSearch: Search,
    },
    beforeCreate() {
      this.$store.dispatch("checkLogin");
    },
    mounted() {
      this.$store.dispatch("directLanding", false);
    },
    computed: {
      headerTitle() {
        return this.$store.getters.headerTitle;
      },
      headerType() {
        return this.$store.getters.headerType;
      },
      isSearchShown() {
        return this.$store.getters.isSearchShown;
      }
    },
    methods: {
      wrapperClickMethods() {
        this.$store.dispatch("changePcSearchMode", false);
      }
    }
  }
</script>

<style lang="scss">
.two-columns {
  display: flex;
  justify-content: space-between;
  width: 800px;
  margin: 0 auto;
  padding: 20px 0;
  @media screen and (max-width: 768px){
    display: block;
    width: auto;
    padding: 20px 15px;
  }
  &__main {
    width: calc(100% - 230px);
    @media screen and (max-width: 768px){
      width: auto;
    }
  }
  &__side {
    width: 210px;
    @media screen and (max-width: 768px){
      width: auto;
    }
  }
}

.grey-select-box {
  border: 1px solid #D8D8D8;
  width: 100%;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue